import React from 'react';
import styles from './Board.module.css';
import Piece from '../Piece/Piece';
import { BoardState, Coordinate, PlayerColor } from '../../../../../../shared/types/game';

interface BoardProps {
  boardData: BoardState;
  selectedSquare: Coordinate | null;
  onSquareClick: (row: number, col: number) => void;
  currentPlayer: PlayerColor;
  highlightedMoves: Coordinate[];
}

const Board: React.FC<BoardProps> = ({ boardData, selectedSquare, onSquareClick, currentPlayer, highlightedMoves }) => {
  const rowsToRender = currentPlayer === 'sente' ? [0, 1, 2, 3, 4, 5, 6, 7, 8] : [8, 7, 6, 5, 4, 3, 2, 1, 0];
  const colsToRender = currentPlayer === 'sente' ? [0, 1, 2, 3, 4, 5, 6, 7, 8] : [8, 7, 6, 5, 4, 3, 2, 1, 0];

  return (
    <div className={styles.shogiBoard}> 
      {rowsToRender.map(rowIndex => (
        <div key={rowIndex} className={styles.boardRow}>
          {colsToRender.map(colIndex => {
            const pieceData = boardData[rowIndex][colIndex];
            const isSelected = selectedSquare && selectedSquare.row === rowIndex && selectedSquare.col === colIndex;
            // このマスがハイライトされるべき合法手かどうかを判定
            const isHighlighted = highlightedMoves.some(
              (move) => move.row === rowIndex && move.col === colIndex
            );

            // 適用するクラス名を構築
            let squareClasses = styles.boardSquare;
            if (isSelected) {
              squareClasses += ` ${styles.selectedSquare}`;
            }
            // ハイライトされるべきマスであれば、highlightedSquare クラスを追加
            if (isHighlighted) {
              squareClasses += ` ${styles.highlightedSquare}`;
            }

            return (
              <div
                key={`${rowIndex}-${colIndex}`}
                className={squareClasses} // 構築したクラス名を適用
                onClick={() => onSquareClick(rowIndex, colIndex)}
              >
                {pieceData && (
                  <Piece
                    type={pieceData.type}
                    owner={pieceData.owner}
                    viewingPlayerColor={currentPlayer}
                  />
                )}
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default Board;